export default __webpack_public_path__ + "static/media/Ploy.8d13e56e.jpg";